export default class Fornecedor {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.tipo = 0;
        this.nome = '';
        this.cpfCnpj = '';
        this.identidadeInscricaoEstadual = '';
        this.dataNascimentoFundacao = null;
        this.cep = '';
        this.logradouro = '';
        this.numero = '';
        this.complemento = '';
        this.bairro = '';
        this.cidade = '';
        this.estado = '';
        this.pais = '';
        this.telefone = '';
        this.celular = '';
        this.email = '';
        this.situacao = 'A';
        this.observacao = '';

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.tipo = model.tipo;
        this.tipoStr = model.tipoStr;
        this.nome = model.nome;
        this.cpfCnpj = model.cpfCnpj;
        this.cpfCnpjNome = model.cpfCnpjNome;
        this.identidadeInscricaoEstadual = model.identidadeInscricaoEstadual;
        this.dataNascimentoFundacao = model.dataNascimentoFundacao ? new Date(model.dataNascimentoFundacao).yyyymmdd() : null;
        this.cep = model.cep;
        this.logradouro = model.logradouro;
        this.numero = model.numero;
        this.complemento = model.complemento;
        this.bairro = model.bairro;
        this.cidade = model.cidade;
        this.estado = model.estado;
        this.pais = model.pais;
        this.telefone = model.telefone;
        this.celular = model.celular;
        this.email = model.email;
        this.situacao = model.situacao;
        this.situacaoStr = model.situacaoStr;
        this.observacao = model.observacao;
    }
}